module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "center-panel md-scrollbar md-theme-default",
    attrs: {
      "id": "properties"
    }
  }, [_c('module-menu'), _c('md-content', {
    staticClass: "md-layout-row md-gutter md-elevation-1",
    attrs: {
      "md-theme": "white"
    }
  }, [_c('div', {
    staticClass: "md-flex",
    attrs: {
      "md-theme": "white"
    }
  }, [_c('md-table', {
    attrs: {
      "md-theme": "white"
    }
  }, [(!Object.keys(_vm.properties).length) ? _c('md-table-row', [_c('md-table-cell', {
    staticClass: "load"
  }, [_c('span', {
    staticClass: "md-layout-row md-gutter"
  }, [_c('span', {
    staticClass: "md-flex name"
  }, [_vm._v("\"У этой сущности не созданно свойств\"")])])])], 1) : _vm._e(), _vm._l((_vm.properties), function(property) {
    return (Object.keys(_vm.properties).length) ? _c('md-table-row', {
      key: property.id,
      class: (_vm.$route.params.entity_prop_code && _vm.$route.params.entity_prop_code == property.code) ? 'property-row hovered' : 'property-row'
    }, [_c('md-table-cell', {
      staticClass: "left"
    }, [_c('router-link', {
      staticClass: "small md-primary",
      attrs: {
        "to": {
          name: 'EntityProperty',
          params: {
            code: _vm.$route.params.code,
            entity_code: _vm.$route.params.entity_code,
            entity_prop_code: property.code
          },
          query: _vm.$route.query
        }
      }
    }, [_c('span', {
      staticClass: "md-layout-row md-gutter"
    }, [_c('span', {
      staticClass: "md-flex name"
    }, [_vm._v(_vm._s(property.name + ' (' + property.code + ')'))])])])], 1), _c('md-table-cell', {
      staticClass: "right"
    }, [_c('div', {
      staticClass: "actions-wrapper"
    }, [_c('div', {
      staticClass: "actions"
    }, [((['checkbox', 'radio', 'select'].indexOf(property.field_type) + 1)) ? _c('md-button', {
      staticClass: "md-icon-button md-dense small",
      attrs: {
        "to": {
          name: 'EntityPropertyValues',
          params: {
            code: _vm.$route.params.code,
            entity_code: _vm.$route.params.entity_code,
            entity_prop_code: property.code
          }
        }
      }
    }, [_c('md-icon', [_vm._v("playlist_add")])], 1) : _vm._e(), _c('md-button', {
      staticClass: "md-icon-button md-dense small",
      on: {
        "click": function($event) {
          _vm.showRemoveDialog(property.id)
        }
      }
    }, [_c('md-icon', [_vm._v("delete")])], 1)], 1)])])], 1) : _vm._e()
  }), _c('md-button', {
    staticClass: "md-dense",
    attrs: {
      "to": {
        name: 'NewEntityProperty',
        params: {
          code: _vm.$route.params.code
        }
      }
    }
  }, [_vm._v("Добавить свойство "), _c('md-icon', [_vm._v("add")])], 1)], 2)], 1), _c('md-dialog-confirm', {
    attrs: {
      "md-active": _vm.removeDialog,
      "md-title": "Удалить выбранное свойство?",
      "md-content": "Внимание! Действие необратимо!",
      "md-confirm-text": "Удалить",
      "md-cancel-text": "Отмена"
    },
    on: {
      "update:mdActive": function($event) {
        _vm.removeDialog = $event
      },
      "md-cancel": function($event) {
        _vm.removeDialog = false
      },
      "md-confirm": function($event) {
        _vm.removeProperty()
      }
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-545f1848","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/module/views/Entity.vue
// module id = 1148
// module chunks = 0